const productionApi = "https://api.aml-risk-model.com";
const apiHost = productionApi;
// const apiHost = `http://localhost:${process.env.API_PORT || 5000}`;
const s3Bucket = "aml-risk-data.s3";

const config = {
  apiHost,
  staticUrl: `https://${s3Bucket}.amazonaws.com/static`
};

export default config;
